<template>
  <div style="overflow: hidden;">
    <div class="companyText">
      <p class="companyName">公司名称: {{ companyName }}</p>
      <p class="positionname">职位名称: {{ positionName }}</p>
      <p class="positionTime">发布时间：{{ createTime | formatDate }}</p>
    </div>
    <div class="tableBox">
      <el-tabs v-model="activeName">
        <el-tab-pane label="投递人员" name="firstr">
          <div
            class="deliverymsg"
            v-for="(item, index) in delivertNumberList"
            :key="index"
          >
            <div style="display:flex;align-items:center;">
              <img
                class="userimg"
                :src="item.avatar"
                :onerror="defaultImgae"
                alt
              />
              <p class="resumename">{{ item.name }}</p>
            </div>
            <div class="usermsg">
              <span>{{ item.user_info }}</span>
            </div>
            <div class="resumeText">
              <span>{{ item.project_info }}</span>
            </div>
            <div
              class="goDetile"
              @click="
                handleGoDetails(
                  item.id,
                  item.created_at,
                  item.cv_log_id,
                  item.position_id
                )
              "
            >
              <p>看详情＞</p>
            </div>
          </div>
          <div v-show="isShowNoData" class="isShowNoData">暂无更多数据</div>
        </el-tab-pane>
      </el-tabs>
      <div class="pagination">
        <span
          >共{{ total }}条 {{ currentPage }} /
          {{ (total / limit) | getNum }} 页</span
        >
        <el-pagination
          @current-change="handleChangeCurrentPage"
          :current-page.sync="currentPage"
          background
          :page-size="limit"
          prev-text="< 上一页"
          next-text="下一页 >"
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PositionApi from "@/api/PositionModule";
import { formatDate } from "@/assets/js/public";
export default {
  data() {
    return {
      defaultImgae: 'this.src="' + require("../../assets/imgs/hello.png") + '"',
      currentPage: 1,
      total: 0,
      delivertNumberList: [],
      activeName: "firstr",
      companyName: "",
      positionName: "",
      createTime: "",
      PositionId: "",
      limit: 10,
      isShowNoData: false
    };
  },
  filters: {
    getNum: function(value) {
      return Math.ceil(value);
    },
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.$emit("defaultPath", val.meta.record[1].path);
      }
    }
  },
  created() {
    this.PositionId = this.$route.query.id;
    this.handleGetDeliveryNumber();
    this.positionName = sessionStorage.getItem("positionname");
    this.createTime = sessionStorage.getItem("createtime");
    this.companyName = sessionStorage.getItem("companyname");
  },
  methods: {
    // 分页相关
    // 获取选中页数
    handleChangeCurrentPage(e) {
      this.currentPage = e;
      this.handleGetDeliveryNumber();
    },
    // 获取投递人数列表
    handleGetDeliveryNumber() {
      let params = {
        position_id: this.PositionId,
        limit: this.limit,
        page: this.currentPage
      };
      PositionApi.getDeliveryNumber(params)
        .then(res => {
          this.delivertNumberList = res.data.list;
          if (this.delivertNumberList.length === 0) {
            this.isShowNoData = true;
          } else {
            this.isShowNoData = false;
          }
          this.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 跳转简历详情
    handleGoDetails(id, created_at, cv_log_id, position_id) {
      sessionStorage.setItem("historyjob" + created_at, created_at);
      // 形参传入
      let resumeid = id;
      this.$router.push({
        path: "/resumedetails",
        query: { id: resumeid, cv_log_id: cv_log_id, position_id: position_id }
      });
    }
  }
};
</script>
<style scoped>
.isShowNoData {
  text-align: center;
  font-size: 16px;
  color: #999;
  margin-top: 20px;
}
.positionTitle {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  margin-top: 9px;
}
.companyText {
  position: absolute;
  top: 84px;
  width: 1067px;
  height: 75px;
  border-left: 3px solid #0077ff;
  padding-left: 10px;
}
.companyText .companyName {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
}
.companyText .positionname {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-top: 11px;
}
.companyText .positionTime {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-top: 9px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: 30px;
}
.pagination span {
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}
.tableBox {
  width: 1020px;
  min-height: 600px;
  margin-top: 100px;
  background-color: #fff;
  padding-left: 30px;
  padding-right: 30px;
}
.deliverymsg {
  width: 100%;
  height: 76px;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.deliverymsg div:first-child {
  flex: 0 0 15%;
}
.deliverymsg div:nth-child(2) {
  flex: 0 0 25%;
}
.deliverymsg div:nth-child(3) {
  flex: 0 0 40%;
}
.deliverymsg .userimg {
  display: inline-block;
  width: 36px;
  height: 36px;
  /* border: 1px solid #ccc; */
  border-radius: 50%;
  margin-right: 8px;
}
.deliverymsg .resumename {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.deliverymsg .usermsg span {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
}
.deliverymsg .resumeText span {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
}
.deliverymsg .goDetile {
  font-size: 12px;
  color: rgba(0, 119, 255, 1);
  margin-right: 30px;
  text-align: center;
}
.deliverymsg .goDetile p {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/position/deliveryNumber.vue